import FormItem from './FormItem';


FormItem.install = function(Vue) {
  Vue.component(FormItem.name, FormItem);
};

export default FormItem;
